/**
 * @generated SignedSource<<b76a7fae24d0c85a58ace0e9aaeb1913>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MealLoggingSettingsDrawer_workspace$data = {
  readonly mealLoggingQuestions: string;
  readonly mealLoggingQuestionsTotal: number;
  readonly " $fragmentType": "MealLoggingSettingsDrawer_workspace";
};
export type MealLoggingSettingsDrawer_workspace$key = {
  readonly " $data"?: MealLoggingSettingsDrawer_workspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"MealLoggingSettingsDrawer_workspace">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MealLoggingSettingsDrawer_workspace",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mealLoggingQuestions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mealLoggingQuestionsTotal",
      "storageKey": null
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};

(node as any).hash = "f4730148382c54dc6d9b3a6ff3da75de";

export default node;
